var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 22.9999L9.05 18.7812C9.215 18.3499 9.48083 18.0076 9.8475 17.7541C10.2142 17.5006 10.6267 17.3742 11.085 17.3749H12.9V12.8468C10.095 12.7531 7.74357 12.3312 5.8457 11.5812C3.94783 10.8312 2.99927 9.94994 3 8.93744C3 7.84994 4.0725 6.92181 6.2175 6.15306C8.3625 5.38431 10.9567 4.99994 14 4.99994C17.0617 4.99994 19.6606 5.38431 21.7968 6.15306C23.933 6.92181 25.0007 7.84994 25 8.93744C25 9.94994 24.0511 10.8312 22.1532 11.5812C20.2553 12.3312 17.9043 12.7531 15.1 12.8468V17.3749H16.915C17.355 17.3749 17.7631 17.5017 18.1393 17.7552C18.5155 18.0087 18.7857 18.3507 18.95 18.7812L20.6 22.9999H18.4L17.08 19.6249H10.92L9.6 22.9999H7.4ZM14 10.6249C15.7783 10.6249 17.4558 10.4656 19.0325 10.1468C20.6092 9.82806 21.7642 9.42494 22.4975 8.93744C21.7642 8.44994 20.6092 8.04681 19.0325 7.72806C17.4558 7.40931 15.7783 7.24994 14 7.24994C12.2217 7.24994 10.5442 7.40931 8.9675 7.72806C7.39083 8.04681 6.23583 8.44994 5.5025 8.93744C6.23583 9.42494 7.39083 9.82806 8.9675 10.1468C10.5442 10.4656 12.2217 10.6249 14 10.6249Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableWhite);
export default __webpack_public_path__ + "static/media/table_white.557b7f9908d6b7c54209678f132bd517.svg";
export { ForwardRef as ReactComponent };